<template>
  <tr v-if="qrCodePathList.length>0">
    <th>查看发票</th>
    <td colspan="3">
      <div v-for="(path) in qrCodePathList" :key="path">
        <a target="_blank" :href="path">{{ path }}</a>
      </div>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'InvoiceAttendModalTr',
  props: {
    orderId: {
      type: String,
      default: ''
    }
  },
  created () {
    this.getQrCodePath(this.orderId)
  },
  watch: {
    orderId (value) {
      this.getQrCodePath(value)
    }
  },
  data () {
    return {
      qrCodePathList: []
    }
  },
  methods: {
    async getQrCodePath (orderId) {
      this.qrCodePath = ''
      const res = await this.$http.get('/api/1/pt/list_qr_code_path_by_ref_id.json', { params: { refId: orderId } })
      if (res.result) {
        this.qrCodePathList = res.result.qrCodePathList
      }
    }
  }
}
</script>

<style scoped>

</style>
